/*
 * @Author: DG
 * @Date: 2021-10-22 14:09:55
 * @LastEditors: DG
 * @LastEditTime: 2022-03-03 17:34:51
 * @Description: file content
 */
/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import { registerMicroApps, start } from 'qiankun';
import { longanDispatch } from 'longan-sdk';

const path = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? `:${window.location.port}` : ''
}`;
const microUrl = ['/schedule', '/report'];
const { ENV } = window.__SMART__;

export const checkMicroUrl = (location, url) => {
  return url.find((item) => location.pathname.includes(item));
};

console.log('path', path);
console.log('ENV', ENV);

const config = () => {
  if (ENV === 'dev') {
    return [
      {
        name: 'ptp',
        entry: '//localhost:4001',
        container: '#ptp-container',
        activeRule: microUrl,
        props: {
          longanDispatch,
        },
      },
      {
        name: 'ptp_assist',
        entry: '//localhost:4001',
        container: '#smart-root',
        activeRule: '/assist',
      },
    ];
  }
  return [
    {
      name: 'ptp',
      entry: `${path}/ptp/`,
      container: '#ptp-container',
      activeRule: microUrl,
      props: {
        longanDispatch,
      },
    },
    {
      name: 'ptp_assist',
      entry: `${path}/ptp/`,
      container: '#smart-root',
      activeRule: '/assist',
    },
  ];
};

registerMicroApps(config(), {
  beforeLoad: [(app) => {}],
  beforeMount: [(app) => {}],
  afterUnmount: [(app) => {}],
});

/**
 * Step3 启动应用
 */
start({ prefetch: 'all' });
